import { createAction, props } from '@ngrx/store';
import { InvoiceDocumentDetailModel } from '../../models/invoice/invoice-document-detail.model';
import { InvoiceDocumentOverviewModel } from '../../models/invoice/invoice-document-overview.model';
// /* Invoice Document Overview *//

// Delete one or more Invoice Documents
export const deleteInvoiceDocumentOverview = createAction(
  '[Invoice] Delete Invoice Document',
  props<{ payload: InvoiceDocumentOverviewModel }>(),
);

export const invoiceDocumentOverviewDeleted = createAction(
  '[Invoice] Invoice Document Deleted',
  props<{ payload: InvoiceDocumentOverviewModel }>(),
);

// Fetch a list of previously generated Invoice Documents (optional filter)
export const fetchInvoiceDocumentOverview = createAction('[Invoice] Fetch Invoice Document List');

// Set the list of Invoice Documents in state
export const setInvoiceDocumentOverview = createAction(
  '[Invoice] Set Invoice Document List',
  props<{ payload: InvoiceDocumentOverviewModel[] }>(),
);

// /* Invoice Document Detail *//
// Fetch all Invoice Documents (optionally filtered)
export const fetchInvoiceDocuments = createAction(
  '[Invoice] Fetch Invoice Documents',
  props<{ payload: boolean }>(),
);

export const setInvoiceDocuments = createAction(
  '[Invoice] Set Invoice Documents',
  props<{ payload: InvoiceDocumentDetailModel[] }>(),
);

// Fetch a single Invoice Document
export const fetchSingleInvoiceDocument = createAction(
  '[Invoice] Fetch Single Invoice Document',
  props<{ payload: number }>(),
);

export const setSingleInvoiceDocument = createAction(
  '[Invoice] Set Single Invoice Document',
  props<{ payload: InvoiceDocumentDetailModel }>(),
);

// Trigger an Invoice Document generation
export const generateInvoiceDocument = createAction(
  '[Invoice] Generate Invoice Document',
  props<{ payload: InvoiceDocumentDetailModel }>(),
);

// When an Invoice Document has been successfully generated
export const invoiceDocumentGenerated = createAction(
  '[Invoice] Invoice Document Generated',
  props<{ payload: InvoiceDocumentDetailModel }>(),
);

export const updateInvoiceDocument = createAction(
  '[Invoice] Update Invoice Document',
  props<{ payload: InvoiceDocumentDetailModel }>(),
);

export const invoiceDocumentUpdated = createAction(
  '[Invoice] Invoice Document Updated',
  props<{ payload: InvoiceDocumentDetailModel }>(),
);

export const deleteInvoiceDocument = createAction(
  '[Invoice] Delete Invoice Document',
  props<{ payload: InvoiceDocumentDetailModel }>(),
);

export const invoiceDocumentDeleted = createAction(
  '[Invoice] Invoice Document Deleted',
  props<{ payload: InvoiceDocumentDetailModel }>(),
);

// Common failure action for any Invoice-related HTTP errors
export const httpFail = createAction('[Invoice] Http Fail', props<{ payload: string }>());
